import React, { useState, useEffect, useRef } from "react";
import ContentEditable from "react-contenteditable";
import HHCommentAI from "../../../Generic/HHCommentAI";
import SvgIcon from "../../../Generic/SvgIcon";
import Lightning from "../../../../assets/images/Lightning.svg";
import LcTooltip from "../../../Generic/LcTooltip";

interface Props {
    text: string;
    placeholder?: string;
    showToolBar?: boolean;
    optionsFormatedType: any;
    mentions?: any
    userMention: Function,
    removeMention?: Function
    selectedMentions?: any
    removedMention?: any
    refreshRemoved?: Function
    setText: Function
    suggestion?: boolean
    user?: any
    solicitation?: any
    suggestionStyle?: any
    useTextOptions?: boolean
    textboxStyle?: any
}

const ScriptEditor: React.FC<Props> = (props) => {
    const [text, setText] = useState(props.text || "");
    const [focused, setFocused] = useState(false);
    const [replacedUser, setReplacedUser] = useState<string>("")
    const editorRef: any = useRef(null);
    const [sugestaoExp, setSugestaoExp] = useState<boolean>(false);

    useEffect(() => {
        if (text === "") {
            setText(props.placeholder || "");
        }
    }, []);

    useEffect(() => {
        setText(props.text || "");
    }, [props.text]);

    useEffect(() => {
        if (props.selectedMentions && props.selectedMentions.length > 0 && text) {
            const mentionName = props.selectedMentions[0].name;
            const mentionId = props.selectedMentions[0].id;
            let string = text;
            let stringToReplace = `<strong data-mention-id="${mentionId}">${mentionName.toLowerCase()}</strong>&nbsp`;
            let newString = string.replace(replacedUser, stringToReplace);
            setText(newString);
        }
    }, [props.selectedMentions]);

    useEffect(() => {
        if (props.removedMention && text) {
            removeMention();
        }
    }, [props.removedMention]);

    const removeMention = (userLocal?: any) => {
        let string = text;
        let replacedString = `<strong data-mention-id="${props.removedMention.id}">${(props.removedMention.name).toLowerCase()}</strong>`;

        if (string.includes(replacedString)) {
            // let newString = string.replace(replacedString, (props.removedMention.name).toLowerCase());
            let newString = string.replace(replacedString, ("").toLowerCase());
            setText(newString);
        }

        props.refreshRemoved && props.refreshRemoved(undefined);
    }
    useEffect(() => {
        if (props.useTextOptions) document.execCommand("bold", false, props.optionsFormatedType.bold);
    }, [props.optionsFormatedType.bold]);

    useEffect(() => {
        if (props.useTextOptions) document.execCommand("italic", false, props.optionsFormatedType.italic);
    }, [props.optionsFormatedType.italic]);

    useEffect(() => {
        if (props.useTextOptions) document.execCommand("strikeThrough", false, props.optionsFormatedType.strikeThrough);
    }, [props.optionsFormatedType.strikeThrough]);

    useEffect(() => {
        if(props.showToolBar && editorRef.current) editorRef.current.focus();
    }, [props.showToolBar]);

    const handleChange = (e) => {
        const inputType = e.nativeEvent.inputType;

        let texto = e.target.value;

        // if (inputType === "insertFromPaste") {
        //     texto = texto.replace(/<[^>]*>/g, "")
        // }

        // if ((inputType === "insertFromPaste") && e.target.value.includes("<img ")) {
        //     return;
        // }

        props.mentions.forEach(user => {
            for (let index = user.name.length; index > 0; index--) {
                var teste = user.name.slice(0, index);

                if (texto.includes(`<strong data-mention-id="${user.id}">${teste.toLowerCase()}</strong>`) && teste.length <= 4) {
                    user.name = teste;
                    props.removeMention && props.removeMention(user, "mention");
                }
            }
        });

        setText(texto);
        props.setText(texto);
    };

    const handleFocus = () => {
        if (text === (props.placeholder || "")) {
            setText("");
        }

        setFocused(true);
    };

    const handleBlur = () => {
        setFocused(false);
    };

    const handleUserMention = (e: any) => {
        if (e.target.innerText.indexOf("@") >= 0 && e.target.keyCode !== 32) {
            let userName = e.target.innerText.slice(e.target.innerText.indexOf("@") + 1);
            let userToReplace = e.target.innerText.slice(e.target.innerText.indexOf("@")).trimEnd();
            setReplacedUser(userToReplace);
            props.userMention && props.userMention(userName.includes(".com") ? "" : userName);
        }
    }

    const pasteImage = async (event) => {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;

        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                event.preventDefault();
                return;
            }
        }
    }

    const handleCleanText = () => {
        const texto = text
            .replace(/&nbsp;/g, "")             // Substitua todas as ocorrências de '&nbsp;' por uma string vazia
            .replace(/<br>/g, "")               // Substitua todas as ocorrências de '<br>' por uma string vazia
            .replace(/<div>(\s*)<\/div>/g, "")  // Substitua todas as ocorrências de '<div> </div>' por uma string vazia
            .trimEnd();
            
        return texto;
    }

    return (
        <>
            <>
                {
                    props.suggestion &&
                    <div style={{ marginTop: "-45px" }}>
                        <div
                            style={props.suggestionStyle}
                            onClick={(e) => {
                                if ((handleCleanText()).length > 0) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setSugestaoExp(!sugestaoExp);
                                }

                                handleCleanText();
                            }}
                        >
                            <LcTooltip
                                content={((handleCleanText()).length > 0) ? "Sugestão gerada por AI" : "Digite algo para habilitar a sugestão expandida"}
                                trigger={"hover"}
                                position={"left"}
                            >
                                <SvgIcon
                                    icon={Lightning}
                                    height={25}
                                    width={25}
                                    disabled={(handleCleanText()).length === 0}
                                    active={sugestaoExp}
                                />
                            </LcTooltip>
                        </div>
                        <HHCommentAI
                            title={'Sugestão gerada por AI'}
                            withOriginalText
                            modal={true}
                            originalText={text}
                            visible={sugestaoExp}
                            user={props.user}
                            solicitation={props.solicitation}
                            handleVisible={(value) => setSugestaoExp(value)}
                            setText={(e) => { setText(e); props.setText(e); }}
                            conclusion={true}
                            style={{
                                right: "20px",
                                bottom: "-4vh",
                                transform: "translateY(-50%)"
                            }}
                        />
                    </div>
                }
            </>
            <div style={{ marginTop: (props.suggestion) ? "15px" : "0", height: "calc(100% - 10px)" }}>
                <ContentEditable
                    innerRef={editorRef}
                    html={text}
                    onChange={handleChange}
                    tagName={"div"}
                    className={"editor-content"}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    contentEditable={!focused}
                    onKeyUp={handleUserMention}
                    onPaste={pasteImage}
                    style={{
                        ...props.textboxStyle, 
                        color: (text === props.placeholder) ? "#bababa" : "#000",
                        height: "100%",
                        display: (!props.showToolBar) ? "flex" : "inherit",
                        alignItems: "center",
                        fontSize: "14px",
                        flexDirection: 'column'
                    }}
                />
            </div>
        </>
    );
};

export default ScriptEditor;